import React from "react";
import { AutoBind } from "../../rule-engine-core/Common/AutoBind";
import { StateManager } from "../../rule-engine-core/Common/StateManager";
import { FlowStepSequence } from "../../rule-engine-core/Flow/Structure/FlowStepSequence";
import { FlowStepData } from "../../rule-engine-core/Flow/Steps/FlowStepData";

interface ISequenceTitle {
    sequence: FlowStepSequence;
}

export abstract class BaseSequenceTitle extends React.Component<ISequenceTitle> {
    @AutoBind
    onUpdateStackName(s: FlowStepData | FlowStepSequence, name: string) {
        if (name.length <= 30) {
            s.name = name;
            StateManager.propertyChanged(s, FlowStepData.NAME);
        }
    }
}
